export default "__VITE_ASSET__Djsp83pc__"